import { useEffect } from "react";
import { Form } from "../types";

const useClearFormOnUnmount = (form: Form): void => {
  useEffect(() => {
    return () => form.clear();
  }, [form, form.clear]);
};

export default useClearFormOnUnmount;
